// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weight-100 {
  font-weight: 100;
}

.weight-200 {
  font-weight: 200;
}

.weight-300 {
  font-weight: 300;
}

.weight-400 {
  font-weight: 400;
}

.weight-500 {
  font-weight: 500;
}

.weight-600 {
  font-weight: 600;
}

.weight-700 {
  font-weight: 700;
}

.weight-800 {
  font-weight: 800;
}

.weight-900 {
  font-weight: 900;
}

.size-10 {
  font-size: 0.625rem;
}

.size-11 {
  font-size: 0.6875rem;
}

.size-12 {
  font-size: 0.75rem;
}

.size-13 {
  font-size: 0.8125rem;
}

.size-14 {
  font-size: 0.875rem;
}

.size-15 {
  font-size: 0.9375rem;
}

.size-16 {
  font-size: 1rem;
}

.size-17 {
  font-size: 1.0625rem;
}

.size-18 {
  font-size: 1.125rem;
}

.size-19 {
  font-size: 1.1875rem;
}

.size-20 {
  font-size: 1.25rem;
}

.size-21 {
  font-size: 1.3125rem;
}

.size-22 {
  font-size: 1.375rem;
}

.size-23 {
  font-size: 1.4375rem;
}

.size-24 {
  font-size: 1.5rem;
}

.size-25 {
  font-size: 1.5625rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AACA;EACI,oBAAA;AAEJ;;AAAA;EACI,kBAAA;AAGJ;;AADA;EACI,oBAAA;AAIJ;;AAFA;EACI,mBAAA;AAKJ;;AAHA;EACI,oBAAA;AAMJ;;AAJA;EACI,eAAA;AAOJ;;AALA;EACI,oBAAA;AAQJ;;AANA;EACI,mBAAA;AASJ;;AAPA;EACI,oBAAA;AAUJ;;AARA;EACI,kBAAA;AAWJ;;AATA;EACI,oBAAA;AAYJ;;AAVA;EACI,mBAAA;AAaJ;;AAXA;EACI,oBAAA;AAcJ;;AAZA;EACI,iBAAA;AAeJ;;AAbA;EACI,oBAAA;AAgBJ","sourcesContent":[".weight-100 {\n    font-weight: 100;\n}\n\n.weight-200 {\n    font-weight: 200;\n}\n\n.weight-300 {\n    font-weight: 300;\n}\n\n.weight-400 {\n    font-weight: 400;\n}\n\n.weight-500 {\n    font-weight: 500;\n}\n\n.weight-600 {\n    font-weight: 600;\n}\n\n.weight-700 {\n    font-weight: 700;\n}\n\n.weight-800 {\n    font-weight: 800;\n}\n\n.weight-900 {\n    font-weight: 900;\n}\n\n.size-10 {\n    font-size: 0.6250rem;\n}\n.size-11 {\n    font-size: 0.6875rem;\n}\n.size-12 {\n    font-size: 0.7500rem;\n}\n.size-13 {\n    font-size: 0.8125rem;\n}\n.size-14 {\n    font-size: 0.8750rem;\n}\n.size-15 {\n    font-size: 0.9375rem;\n}\n.size-16 {\n    font-size: 1.0000rem;\n}\n.size-17 {\n    font-size: 1.0625rem;\n}\n.size-18 {\n    font-size: 1.1250rem;\n}\n.size-19 {\n    font-size: 1.1875rem;\n}\n.size-20 {\n    font-size: 1.2500rem;\n}\n.size-21 {\n    font-size: 1.3125rem;\n}\n.size-22 {\n    font-size: 1.3750rem;\n}\n.size-23 {\n    font-size: 1.4375rem;\n}\n.size-24 {\n    font-size: 1.5000rem;\n}\n.size-25 {\n    font-size: 1.5625rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
